<template>
  <div
    ref="modalContainer"
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    style="display: block;"
    @click="onBackdrop"
  >
    <div class="modal-dialog" :class="classes" role="document">
      <div class="modal-content">
        <component
          :is="component"
          :input="input"
          @fechar="$emit('fechar', $event)"
          @dispensar="$emit('dispensar', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HcBaseModal",
  props: {
    component: {
      type: [Object, Function],
      required: true
    },
    input: {
      default: null
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    classes
  },
  methods: {
    onBackdrop
  }
};

function classes() {
  return [
    this.options.size ? `modal-${this.options.size}` : "",
    {
      "modal-dialog-centered": this.options.top !== true
    }
  ];
}

function onBackdrop(event) {
  if (
    this.options.backdrop !== false &&
    event.target === this.$refs.modalContainer
  ) {
    this.$emit("dispensar");
  }
}
</script>
